import { Component, Prop, h } from "@stencil/core";
import { Control } from "@genexus/designer-common";
import { getGxmlNode } from "../../../utils";

@Component({
  styleUrl: "designer-tool-identity.scss",
  tag: "gx-designer-tool-identity"
})
export class DesignertoolIdentity {

  @Prop() control: Control;

  render() {

    let node = getGxmlNode(this.control);
    let type = node ? node.descriptor.getDisplayName(node, this.control.site) : '';
    let name = node ? node.name : '';

    return (
      <div class="identity">
        <span class="type-name">
          {type}
        </span>
        <span style={{
          whiteSpace: 'pre'
        }}>{` ${name}`}</span>
      </div>
    );
  }
}
